export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DataReassignmentDialog.json?hash=bc3b381a72393949fe7d0cb598d904bb";